(function () {
  'use strict';

  /* ------------------------------------------------
   * Click handler using event delegation
   * Handles dynamically re-rendered cart drawers
   * ------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#gale-hsa-cart-btn');
    if (!btn) return;

    e.preventDefault();

    btn.disabled = true;
    btn.textContent = 'Redirecting\u2026';

    // Set hsa_mode cart attribute so the payment customization
    // function hides all non-Gale payment methods at checkout
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { hsa_mode: 'true' } })
    })
    .then(function () {
      window.location.href = '/checkout';
    })
    .catch(function (err) {
      console.error('[Gale] Failed to set HSA mode:', err);
      btn.disabled = false;
      btn.textContent = 'Checkout with HSA/FSA';
      window.location.href = '/checkout';
    });
  });
})();